<div class="nova-font-style">
  <div class="wizard top-margin-15" *ngIf="!dataLoading">
    <div class="row">
      <div class="col s12 m12 l12 xl12">
        <div>
          <div>
            <kendo-stepper [steps]="steps" [stepType]="'label'" [(currentStep)]="current" [linear]="true"
              [style.width]="100">
            </kendo-stepper>
          </div>
          <div>
            <kendo-progressbar [value]="progressValue" [label]="labelSettings">
            </kendo-progressbar>
          </div>
        </div>
        <div class="tabstrip-wrapper nova-font-style benefit-wizard">
          <kendo-tabstrip #tabstrip>
            <kendo-tabstrip-tab title="Person Info" selected="true">
              <ng-template kendoTabContent>
                <app-person-info (goTo)="setCurrentScreen($event)" (formDirtyOrTouched)="disableHistory($event)"
                  [personScreenInfo]="wizardData">
                </app-person-info>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Enrollment Info">
              <ng-template kendoTabContent>
                <app-enrollment-info (goTo)="setCurrentScreen($event)" [personInfo]="wizardData"></app-enrollment-info>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Contact Info">
              <ng-template kendoTabContent>
                <contact-info (goTo)="setCurrentScreen($event)" [personInfo]="wizardData"></contact-info>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </div>
      </div>
    </div>
  </div>
  <div class="k-icon k-i-loading outer" *ngIf="dataLoading"></div>
</div>